/**
 * Step are :
 * 1. Check if the account is whitelisted
 * 2. If whitelisted, the account can claim his whitelist access: whitelistOffer
 *    2.a. The account claimed his whitelist access
 *      3.a Then the user added contact info
 *      3.b Then the user did not yet add contact info. Can add with the banner ?
 *    2.b. The account don't claim. He can claim with the banner later
 *
 * 3. If not whitelisted, the user can join on the waitlist: waitlistOffer
 *  3.a Then the user joins the waitlist and has a rank
 *    3.a.i The user is already an LP, fetched from Airtable. He can claim boost : boostOffer
 *      3.a.i.a Then the user claimed his bonus XP points. Congrats Popup shown
 *      3.a.i.b Then the user did not yet received bonus XP points
 *  3.b Then the user is not on the waitlist. He can join from the banner
 */
import { getWaitlistState } from './waitlist-localstorage'
import { isWhitelisted, wasLP } from './airtable'
import { Zealy, zealyStatus } from './zealy'
import dotenv from 'dotenv'

dotenv.config()

const swaapEnvironment = process.env.REACT_APP_SWAAP_ENVIRONMENT

const apiPrefix =
  swaapEnvironment === 'prod' ? '/web/whitelist' : '/web/whitelist/staging'

export const accountStateBackendUrl =
  process.env.REACT_APP_ACCOUNT_STATE_URL + apiPrefix

export interface WaitlistState {
  zealyId: string | undefined
  offerPopupShown: boolean
  isExistingLP: boolean
  rank: number | undefined
  receivedXpBonus: boolean
  showXpBonusCongrats: boolean
  showDenyPopup: boolean
}

export interface WhitelistState {
  offerPopupShown: boolean
  claimed: boolean
  showContactPopup: boolean
  contactAdded: boolean
  showDenyPopup: boolean
}

export interface AccountState {
  address: string
  whitelisted: boolean
  whitelistState?: WhitelistState // undefined if not whitelisted
  onWaitlist: boolean // false if whitelisted
  waitlistState: WaitlistState // undefined if whitelisted or not on waitlist
}

export const defaultWaitlistState: WaitlistState = {
  offerPopupShown: true, // to avoid showing at start
  isExistingLP: false,
  zealyId: undefined,
  rank: undefined,
  receivedXpBonus: false,
  showXpBonusCongrats: false, // to avoid showing at start
  showDenyPopup: false,
}

export async function fetchAccountState(
  address: string
): Promise<AccountState> {
  const whitelistState = await isWhitelisted(address)

  const accountState: AccountState = {
    address,
    whitelisted: !!whitelistState,
    whitelistState: whitelistState ? whitelistState : undefined,
    onWaitlist: false,
    waitlistState: defaultWaitlistState,
  }

  // Now update with localstorage
  const waitlistState = getWaitlistState(address)

  if (accountState.whitelisted && accountState.whitelistState) {
    accountState.whitelistState = {
      ...accountState.whitelistState,
      offerPopupShown: waitlistState.whitelistOfferPopupHasBeenShown,
    }
  }

  // zealy is often buggy...
  let zealy: Zealy | false = false
  try {
    zealy = await zealyStatus(address)
  } catch (e: any) {
    console.error('Unable to fetch zealy status', e.message)
  }

  accountState.onWaitlist = !!zealy
  accountState.waitlistState = await handleWaitlistState(accountState, zealy)

  return accountState
}

async function handleWaitlistState(
  accountState: AccountState,
  zealy: Zealy | false
): Promise<WaitlistState> {
  // offerPopupShown from localstorage
  const waitlistStateFromStorage = getWaitlistState(accountState.address)
  const offerShown = waitlistStateFromStorage.waitlistOfferPopupHasBeenShown

  // isExistingLP
  const lpResponse = await wasLP(accountState.address)
  const lp = lpResponse.wasLP

  //rank ; 0 if not registered yet
  const rank = zealy ? zealy.rank : 0
  const zealyId = zealy ? zealy.zealyId : undefined
  // bonus
  const receivedXpBonus = !!zealy && lp && lpResponse.receivedXpBonus

  // xpBonusCongratsPopupShown from localstorage

  const waitlistStateToReturn: WaitlistState = {
    offerPopupShown: offerShown,
    isExistingLP: lp,
    rank,
    receivedXpBonus,
    showXpBonusCongrats: false,
    zealyId,
    showDenyPopup: false,
  }
  return waitlistStateToReturn
}
